import { defineComponent, useSlots, computed } from '@vue/composition-api';
import __vue_component__ from './SbExperimentVariation.vue.js';
import { useExperiment } from '../useExperiment.js';

var script = defineComponent({
    props: {
        id: {
            type: String,
            required: true,
        },
        defaultGroup: {
            type: String,
            required: false,
            default: null,
        },
        defaultGroupWhenNotLoggedIn: {
            type: String,
            required: false,
            default: null,
        },
    },
    setup: function (props) {
        var _a = useExperiment(), service = _a.service, isLoadingExperiments = _a.isLoadingExperiments;
        var slots = useSlots();
        var slotNamesLower = Object.keys(slots).map(function (s) { return s.toLowerCase(); });
        var experimentGroup = computed(function () {
            var _a;
            if ((isLoadingExperiments === null || isLoadingExperiments === void 0 ? void 0 : isLoadingExperiments.value) || !(service === null || service === void 0 ? void 0 : service.value)) {
                return null;
            }
            var allExperiments = service.value.getExperiments();
            var experiment = allExperiments.find(function (e) { return e.id.toLowerCase() === props.id.toLowerCase()
                && slotNamesLower.includes(e.group.toLowerCase())
                && e.status === 'enabled'; });
            var isLoggedInContext = !!((_a = service.value.context) === null || _a === void 0 ? void 0 : _a.playerId);
            if (!experiment) {
                /*
                No such experiment found. This can be timeout,
                network error, etc. Or it can be that your experiment
                is a logged in experiment, and you might not be logged in,
                which means the api doesn't return that experiment.
                */
                return isLoggedInContext ? props.defaultGroup : props.defaultGroupWhenNotLoggedIn;
            }
            return experiment.group;
        });
        return {
            experimentGroup: experimentGroup,
        };
    },
    components: {
        SbExperimentVariation: __vue_component__,
    },
});

export default script;
